import { render, staticRenderFns } from "./AudioIntro.vue?vue&type=template&id=496e5902&scoped=true"
import script from "./AudioIntro.vue?vue&type=script&lang=js"
export * from "./AudioIntro.vue?vue&type=script&lang=js"
import style0 from "./AudioIntro.vue?vue&type=style&index=0&id=496e5902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e5902",
  null
  
)

export default component.exports